import React from "react";
import { Col, Row } from "react-bootstrap";

const AddFormResponseNotificationSection = ({
  responseNotification,
  handleChange,
  handleResponseNotification,
  switchBtnColor,
  inputRef,
  handleInputChange,
  isEmailInvalid,
  alreadyExistsEmail,
  emails,
  removeEmail,
}) => {
  return (
    <Row className="m-3 mx-4 mt-4">
      <Col xs={12}>
        <form>
          <div
            className="d-flex flex-column flex-md-row justify-content-between rounded p-2 gap-5"
            style={{
              border: "1px solid #dee2e6",
              width: "100%",
            }}
          >
            <div
              className="d-flex flex-column"
              style={{
                width: "100%",
                maxWidth: "300px",
              }}
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                }}
              >
                <label
                  className="itemText lable C-dark form-label me-5"
                  style={{ minWidth: "160px" }}
                >
                  Response Notifications?
                </label>
                <div>
                  <input
                    id="switch-response-notification"
                    name="responseNotification"
                    type="checkbox"
                    value={responseNotification}
                    checked={responseNotification}
                    onChange={handleChange}
                    className="switch-checkbox"
                  />
                  <button
                    type="button"
                    className="switch-label"
                    onClick={(e) => {
                      e.preventDefault();
                      handleResponseNotification();
                    }}
                  >
                    <span
                      className={`switch-button ${switchBtnColor(
                        responseNotification
                      )}`}
                    />
                  </button>
                </div>
              </div>
              {responseNotification && (
                <label className="itemText lable C-dark form-label pt-2">
                  Email*
                </label>
              )}
              {responseNotification && (
                <form onSubmit={(e) => e.preventDefault()}>
                  <input
                    type="email"
                    ref={inputRef}
                    onKeyDown={handleInputChange}
                    className="add-form-input p-2"
                    placeholder="Provide emails and press enter"
                  />
                  {(isEmailInvalid || alreadyExistsEmail) && (
                    <span
                      className="text-danger align-self-center"
                      style={{ fontSize: "12px" }}
                    >
                      {isEmailInvalid
                        ? "Invalid Email"
                        : "Email already exists"}
                    </span>
                  )}
                </form>
              )}
            </div>
            {responseNotification && emails?.length > 0 && (
              <div
                className="w-100 d-flex flex-wrap border rounded p-2 overflow-auto"
                style={{
                  border: "1px solid #dee2e6",
                  maxHeight: "130px",
                }}
              >
                {emails?.map((email, index) => (
                  <div
                    key={index}
                    className="d-flex align-items-center rounded px-3 py-2 me-2 mb-2"
                    style={{
                      backgroundColor: "#f1f1f1",
                      height: "40px",
                    }}
                  >
                    <span className="email-text me-2">{email}</span>
                    <span
                      className="email-remove"
                      style={{
                        cursor: "pointer",
                        color: "#888",
                        paddingLeft: "5px",
                      }}
                      onClick={() => removeEmail(index)}
                    >
                      &times;
                    </span>
                  </div>
                ))}
              </div>
            )}
          </div>
        </form>
      </Col>
    </Row>
  );
};

export default AddFormResponseNotificationSection;
